import $axios from 'axios'
import {
    getBilDetailUri,
    billConfirmUri,
    getAccountInfoUri,
    getRefundContractLinkUri
} from '../config/uri'

//账单详情
export function getBilDetail(data) {
    return $axios.post(getBilDetailUri, data)
}

//确认账单
export function getBillConfirm(data) {
    return $axios.post(billConfirmUri, data)
}

// 查询对公账户详情
export function getAccountInfo(data) {
    return $axios.post(getAccountInfoUri, data)
}


// 获取账单退款合同链接接口
// 非科锐的猎企确认账单时需要签署退款合同，签署完成后自动确认账单
export function getRefundContractLink(data) {
    return $axios.post(getRefundContractLinkUri, data)
}